import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css'

const Sidebar = () => {
    const [active, setActive] = useState('dashboard'); // State to track active link

    return (
        <div className="sidebar">
            <h4>Menu</h4>
            <div className="sidebar-options">
                <Link
                    to="/upload-books"
                    className={active === 'option 1' ? 'active' : ''}
                    onClick={() => setActive('option 1')}
                >
                   Book Upload
                </Link>
                <Link
                    to="/upload-user"
                    className={active === 'option 2' ? 'active' : ''}
                    onClick={() => setActive('option 2')}
                >
                   User Management
                </Link>
                <Link
                    to="/activity-report"
                    className={active === 'option 3' ? 'active' : ''}
                    onClick={() => setActive('option 3')}
                >
                    Reports
                </Link>
            <span>
                <Link
                 to="/languages"
                 className={active === 'option 4' ? 'active' : ''}
                 onClick={() => setActive('option 4')}
                 >
                Add Language
                </Link>
            </span>
            </div>
        </div>
    );
};

export default Sidebar;

// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './Sidebar.css';

// const Sidebar = () => {
//     const [active, setActive] = useState('dashboard'); // State to track active link
//     const [isSidebarVisible, setIsSidebarVisible] = useState(false); // State to toggle sidebar visibility

//     const toggleSidebar = () => {
//         setIsSidebarVisible(!isSidebarVisible);
//     };

//     return (
//         <>
//             {/* Toggle Button or Close Button */}
//             {isSidebarVisible ? (
//                 <button 
//                     onClick={toggleSidebar} 
//                     className="close-button"
//                     style={{
//                         position: 'absolute',
//                         top: '10px',
//                         right: '10px',
//                         padding: '5px 10px',
//                         backgroundColor: '#ff5e57',
//                         color: 'white',
//                         border: 'none',
//                         borderRadius: '50%',
//                         fontSize: '18px',
//                         cursor: 'pointer',
//                     }}
//                 >
//                     ✕
//                 </button>
//             ) : (
//                 <button 
//                     onClick={toggleSidebar} 
//                     className="toggle-button"
//                     style={{
//                         position: 'absolute',
//                         top: '10px',
//                         left: '10px',
//                         padding: '10px',
//                         backgroundColor: '#343a40',
//                         color: 'white',
//                         border: 'none',
//                         borderRadius: '5px',
//                         cursor: 'pointer',
//                     }}
//                 >
//                     ☰
//                 </button>
//             )}

//             {/* Sidebar */}
//             {isSidebarVisible && (
//                 <div className="sidebar">
//                     <h4>Sidebar Menu</h4>
//                     <div className="sidebar-options">
//                         <Link
//                             to="/upload-books"
//                             className={active === 'option 1' ? 'active' : ''}
//                             onClick={() => setActive('option 1')}
//                         >
//                             Book Upload
//                         </Link>
//                         <Link
//                             to="/upload-user"
//                             className={active === 'option 2' ? 'active' : ''}
//                             onClick={() => setActive('option 2')}
//                         >
//                             User Management
//                         </Link>
//                         <Link
//                             to="/activity-report"
//                             className={active === 'option 3' ? 'active' : ''}
//                             onClick={() => setActive('option 3')}
//                         >
//                             Reports
//                         </Link>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default Sidebar;


// import React, { useState } from 'react';
// import './Sidebar.css'; // Import your CSS file

// const Sidebar = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleSidebar = () => {
//     setIsOpen(!isOpen);
//   };

//   return (
//     <div className="sidebar-container">
//       <button className="toggle-btn" onClick={toggleSidebar}>
//         {isOpen ? '✖' : '☰'}
//       </button>
//       <div className={`sidebar ${isOpen ? 'show' : ''}`}>
//         <ul>
//           <li>Home</li>
//           <li>About</li>
//           <li>Services</li>
//           <li>Contact</li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;
